import { recordPath, recordRoute } from '@/shared/registry'

/** Where the classroom pages live. */
export const createClassroomPath = '/classes/classrooms/new'
export const classroomRoute = recordRoute('classes', 'classrooms')
export const editClassroomRoute = `${classroomRoute}/edit`

/** A classroom's details page. */
export function classroomPath(id: string): string {
  return recordPath('classes', 'classrooms', id)
}

/** The query parameter that presets the owning organization on Create Classroom. */
export const organizationParameter = 'organization'

/** Create Classroom, owned by the organization given, when one is. */
export function createClassroomFor(organizationId?: string | null): string {
  return organizationId === undefined || organizationId === null || organizationId === ''
    ? createClassroomPath
    : `${createClassroomPath}?${new URLSearchParams({ [organizationParameter]: organizationId }).toString()}`
}

/** The base of Classroom Details' slots (`detailsSlots`). */
export const classroomDetailsSlot = 'classes.classroom-details'

/** The permissions the classroom screens show or hide their actions by. */
export const readClassroomsPermission = 'classes.classrooms.read'
export const writeClassroomsPermission = 'classes.classrooms.write'
export const deleteClassroomsPermission = 'classes.classrooms.delete'

/** The API's classroom endpoints. */
export const classroomsApi = '/classes/v1/classrooms'

export function classroomApi(id: string): string {
  return `${classroomsApi}/${encodeURIComponent(id)}`
}
